import { Sale_Source } from "gen/txn/models_pb"
import { useEnumFilter } from "shared-ts/hooks/useFilter"

import { useWebFilter, UseWebFilterProps } from "./useWebFilter"

const labelMap: Record<Sale_Source, string> = {
  [Sale_Source.UNDEFINED]: "",
  [Sale_Source.POS]: "POS",
  [Sale_Source.ECOMM]: "E-commerce",
}

export const useSaleSourceFilter = ({
  persistInUrl = true,
  initialSelectedOptions = [],
}: Partial<
  Pick<UseWebFilterProps<unknown>, "persistInUrl" | "initialSelectedOptions">
> = {}) =>
  useEnumFilter({
    key: "source",
    label: "Sale source",
    enumeration: Sale_Source,
    labelExtractor: (v: Sale_Source): string => labelMap[v],
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      }),
  })
